/**
 * Expands products with colour variants into individual product cards.
 * Each colour variant becomes its own product with the variant's image and data.
 * Non-colour options (like size) remain as variants within each colour product.
 */
export function expandProductsByColourVariants(products) {
    const expandedProducts = [];
    products.forEach((product) => {
        if (!product.variants || product.variants.length === 0) {
            expandedProducts.push(product);
            return;
        }
        const colourVariants = extractColourVariants(product.variants);
        if (colourVariants.length === 0) {
            expandedProducts.push(product);
            return;
        }
        colourVariants.forEach((colourVariant) => {
            const variantsForColour = getVariantsForColour(product.variants, colourVariant.name);
            if (variantsForColour.length === 0) {
                return;
            }
            const firstVariant = variantsForColour[0];
            const variantImage = getVariantImage(firstVariant);
            if (!firstVariant.price) {
                return;
            }
            const expandedProduct = Object.assign(Object.assign({}, product), { id: `${product.id}-${colourVariant.name.toLowerCase().replace(/\s+/g, '-')}`, title: product.title, image: variantImage || product.image, color: colourVariant.name, variants: variantsForColour, selectedVariant: firstVariant, price: {
                    regular: firstVariant.price.regular,
                    sale: firstVariant.price.sale,
                    special: product.price.special,
                }, customAttributes: Object.assign(Object.assign({}, product.customAttributes), { reviewsIoProductId: product.id, reviewsIoVariants: product.variants }) });
            expandedProducts.push(expandedProduct);
        });
    });
    return expandedProducts;
}
function extractColourVariants(variants) {
    const colourVariants = [];
    const seenColours = new Set();
    variants.forEach((variant) => {
        var _a;
        if (!variant.merged_options) {
            return;
        }
        const colorOption = variant.merged_options.find((option) => option.toLowerCase().includes('colour:') ||
            option.toLowerCase().includes('color:'));
        if (colorOption) {
            const colorName = (_a = colorOption.split(':')[1]) === null || _a === void 0 ? void 0 : _a.trim();
            if (colorName && !seenColours.has(colorName)) {
                seenColours.add(colorName);
                const variantImage = getVariantImage(variant);
                colourVariants.push({
                    name: colorName,
                    image: variantImage,
                    variantId: variant.id,
                });
            }
        }
    });
    return colourVariants;
}
function getVariantsForColour(variants, colourName) {
    return variants.filter((variant) => {
        var _a;
        if (!variant.merged_options) {
            return false;
        }
        const colorOption = variant.merged_options.find((option) => option.toLowerCase().includes('colour:') ||
            option.toLowerCase().includes('color:'));
        if (colorOption) {
            const variantColor = (_a = colorOption.split(':')[1]) === null || _a === void 0 ? void 0 : _a.trim();
            return variantColor === colourName;
        }
        return false;
    });
}
function getVariantImage(variant) {
    var _a;
    if (typeof variant.image === 'string') {
        return variant.image;
    }
    return (_a = variant.image) === null || _a === void 0 ? void 0 : _a.url;
}
